import { Base } from "./Base";

export interface ToothSample extends Base{
  name:string;
  age:number;
  ageMonth:number;
  //isMale:boolean;
  sex:string;
  schoolId:number;
  schoolName:string;
  gradeId:number;
  gradeName:string;
  classId:number;
  className:string;
  hospitalId:number;
  hospitalName:string;
  status:string;

  a1:string;
  a2:string;
  a3:string;
  a4:string;
  b1:string;
  b2:string;
  b3:string;
  b4:string;
  c1:string;
  c2:string;
  c3:string;
  c4:string;
  c5:string;
  result:string;

  initId:number;
  initName:string;
  initDate:string;
  
  fillinId:number;
  fillinName:string;
  fillinDate:string;

  samplingId:number;
  samplingName:string;
  samplingDate:string;

  checkId:number;
  checkName:string;
  checkDate:string;

  parentOpenId:string;
  type:number;

  cat:number;
  code:string;

  phoneNo:string;

  sender:string;
  checker:string;
};

export const initToothSample:ToothSample = {
  id: -1,
  key:-1,
  name: '',
  age:5,
  ageMonth:0,
  sex:'',
  hospitalId: -1,
  hospitalName:'',
  gradeId: -1,
  gradeName:'',
  classId: -1,
  className:'',
  schoolId: -1,
  schoolName:'',
  status:'',
  a1: '否',
  a2: '否',
  a3: '否',
  a4: '否',
  b1: '否',
  b2: '否',
  b3: '否',
  b4: '否',
  c1: '否',
  c2: '否',
  c3: '否',
  c4: '否',
  c5: '否',
  result: '',

  initId:-1,
  initName:'',
  initDate: '',
  fillinId:-1,
  fillinName:'',
  fillinDate: '',
  samplingId:-1,
  samplingName:'',
  samplingDate:'',
  checkId:-1,
  checkName:'',
  checkDate:'',
  parentOpenId: '',
  type: 0,

  cat:-1,
  code:'',
  phoneNo:'',

  sender:'',
  checker:'',
};